import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription, from } from 'rxjs';
import { TaskService } from './../task.service';

import { RecentTasks } from './../tasks';

@Component({
  selector: 'app-recently-completed-tasks',
  templateUrl: './recently-completed-tasks.component.html',
  styleUrls: ['./recently-completed-tasks.component.scss']
})
export class RecentlyCompletedTasksComponent implements OnInit, OnDestroy {
  datasource: RecentTasks[];
  title = 'Recently Completed Tasks';
  subTitle: string;
  items: MenuItem[];
  subscription: Subscription;
  loading = true;
  sourceSelected: RecentTasks;

  constructor(
    private _taskService: TaskService
  ) {}

  ngOnInit() {
    this.subscription = this._taskService.getCompletedTask().subscribe((res) => {
      this.datasource = res['data'];
      this.loading = false;
    });
  }

  getMenuItems(item) {
    return this._taskService.getCompletedTaskMenuItems(item);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getPropertyViewUri(PropertyId: number): string {
    return this._taskService.getPropertyViewUri(PropertyId);
  }

  getTaskViewUri( eventlocation: string, property_id: number,
    eventTrackingID: number, event_tracking_parent?: number): string {
    return this._taskService.getTaskViewUri(eventlocation, property_id, eventTrackingID, event_tracking_parent);
  }

  displayAddress(op, event, source) {
    this.sourceSelected = source;
    op.show(event);
  }
}
